import { graphqlClient } from "../../../client";
import cancelOrderLineItemDocument from "./cancelOrderLineItemMutation.graphql";
import type { OrderCancellationResultType } from "../../types";

export interface CancelOrderLineItemMutationVariables {
  command: {
    orderId: string;
    lineItemId: string;
    cancelReason?: string;
  };
}

export interface CancelOrderLineItemMutationResult {
  cancelOrderLineItem: OrderCancellationResultType;
}

export async function cancelOrderLineItem(
  orderId: string,
  lineItemId: string,
  cancelReason?: string,
): Promise<OrderCancellationResultType> {
  const { data } = await graphqlClient.mutate<CancelOrderLineItemMutationResult, CancelOrderLineItemMutationVariables>({
    mutation: cancelOrderLineItemDocument,
    variables: {
      command: {
        orderId,
        lineItemId,
        cancelReason,
      },
    },
  });

  return (
    data?.cancelOrderLineItem ?? {
      success: false,
      message: "Unknown error",
      refundedAmount: 0,
    }
  );
}
